import "./App.css";
import React, { useEffect, useState } from "react";
// import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import "./assets/css/page.css";

import Mainpage from "./pages/Mainpage.js";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Service from "./pages/service/Service";
import News from "./pages/news/News";
import NewsAll from "./pages/news/NewsAll";
import Appointment from "./pages/appointment/Appointment";
import ContactUs from "./pages/about/ContactUs";
import Staff from "./pages/about/Staff";
import AboutUs from "./pages/about/AboutUs";
import Article from "./pages/resource/Article";
import Gallery from "./pages/resource/gallery/Gallery";
import Document from "./pages/resource/Document";
// import NavbarService from "./services/navbar";
import ServiceDetail from "./pages/service/ServiceDetail";
import TemplateService from "./services/template";
import Video from "./pages/resource/video/Video";
import GalleryDetail from "./pages/resource/gallery/GalleryDetail";
import VideoDetail from "./pages/resource/video/VideoDetail";
import ActivityAll from "./pages/news/ActivityAll";
import AppointmentDetail from "./pages/appointment/AppointmentDetail";
import ContentDetail from "./pages/ContentDetail";
import Hamburger from "./components/Hamburger";
import Search from "./pages/Search";

function App() {
  let [templateData, setTemplateData] = useState([]);

  useEffect(() => {
    getTemplateData();
  }, []);

  const getTemplateData = async () => {
    try {
      let res = await TemplateService.getTemplate();
      setTemplateData(res);
    } catch {
      console.error();
    }
  };

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/:lang">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Mainpage />
            <Footer data={templateData} />
          </div>
        </Route>

        {/* Service */}
        <Route exact path="/:lang/service">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Service />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/service/:id">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ServiceDetail />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path={`/:lang/newsAndActivity`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <News />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path={`/:lang/newsAndActivity/news`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <NewsAll />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path={`/:lang/newsAndActivity/news/:slug`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ContentDetail page="news" />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path={`/:lang/newsAndActivity/activity`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ActivityAll />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path={`/:lang/newsAndActivity/activity/:slug`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ContentDetail page="activities" />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path="/:lang/appointment">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Appointment />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path={`/:lang/appointment/:id`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <AppointmentDetail />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/contact-us">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ContactUs />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/about-us">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <AboutUs />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/staff">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Staff />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path="/:lang/article">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Article />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path={`/:lang/article/:slug`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ContentDetail page="article" />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path="/:lang/gallery">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Gallery />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/gallery/:slug">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <GalleryDetail />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path="/:lang/video">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Video />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/video/:slug">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <VideoDetail />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/document">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Document />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/search/:tag">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Search />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path="*">
          <Redirect to="/th" />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
